<template>
  <path 
    d="M26.2873 4.48746L2.98725 11.05C2.78891 11.1042 2.61211 11.2182 2.48092 11.3766C2.34974 11.5349 2.27056 11.7298 2.25416 
    11.9348C2.23776 12.1398 2.28495 12.3448 2.38929 12.522C2.49363 12.6992 2.65005 12.8399 2.83725 12.925L13.5373 17.9875C13.7469 
    18.0845 13.9152 18.2529 14.0123 18.4625L19.0748 29.1625C19.1598 29.3497 19.3005 29.5061 19.4777 29.6104C19.6549 29.7148 
    19.8599 29.7619 20.0649 29.7456C20.2699 29.7292 20.4648 29.65 20.6231 29.5188C20.7815 29.3876 20.8955 29.2108 20.9498 
    29.0125L27.5123 5.71246C27.562 5.54243 27.5651 5.36216 27.5212 5.19053C27.4773 5.01891 27.388 4.86225 27.2627 4.73699C27.1375 
    4.61172 26.9808 4.52246 26.8092 4.47856C26.6376 4.43466 26.4573 4.43773 26.2873 4.48746V4.48746Z" 
    stroke-width="2" 
    stroke-linecap="round" 
    stroke-linejoin="round"
  />
  <path
    d="M13.8623 18.1375L19.5123 12.4875" 
    stroke-width="2" 
    stroke-linecap="round" 
    stroke-linejoin="round"
  />
  />
</template>

<script>
export default {

}
</script>

<style scoped>
    path {
        font-size: var(--iconFontSize);
        fill: var(--iconTextColor);
        stroke: var(--iconBorderColor)
    }
</style>

